<!-- ===== Header ===== -->
<div class="card shadow-sm border-0 mb-3">
  <!-- <div class="card-body py-3">
    <h4 class="card-title mb-0 fw-semibold">
      {{ 'MENU.DASHBOARD.categories' | translate }}
    </h4>
  </div> -->
</div>

<!-- ===== Form Card ===== -->
<div class="card shadow-sm border-0">
  <div class="card-body">

    <form (ngSubmit)="updateProduct()" enctype="multipart/form-data">

      <div class="row justify-content-center">
        <div class="col-lg-8"> <!-- نفس العرض بالظبط -->

  <!-- Question -->
<div class="mb-3">
  <label class="form-label fw-medium">
    {{ lang === 'ar' ? 'السؤال' : 'Question' }}
  </label>

  <textarea
    class="form-control"
    rows="3"
    placeholder="{{ lang === 'ar' ? 'السؤال' : 'Question' }}"
    [(ngModel)]="product.question"
    name="question"
  ></textarea>

  <small class="text-danger" *ngIf="errors?.question">
    {{ errors.question[0] }}
  </small>
</div>

  

          <!-- Submit -->
          <div class="d-flex justify-content-end mt-4">
            <button type="submit" class="btn btn-primary px-4">
              {{ 'MENU.DASHBOARD.Save_Changes' | translate }}
            </button>
          </div>

        </div>
      </div>

    </form>

  </div>
</div>